module.exports = __webpack_public_path__ + "img/data-center06.9bb4199f.png";